import { EVENTS } from "../../../../js/constants";

class FormSubmission {
  /**
   * @param {HTMLElement} element - form
   */
  constructor(element) {
    this.element = element;
    this.hiddenClass = "is-hidden";
    this.loadingElement = this.element.querySelector(".js-LoadingAnimation");
    this.submitButton = this.element.querySelector(".js-FskButton");

    this._init();
  }

  /**
   * init
   *
   * @private
   */
  _init() {
    this._bind();
  }

  /**
   * binds events
   *
   * @private
   */
  _bind() {
    this.element.addEventListener(EVENTS.FORM_SUBMITTED, () => {
      this._togglesSubmitButton({ showLoadingEl: true });
    });
    this.element.addEventListener(EVENTS.DONATION_ERROR, () => {
      this._togglesSubmitButton({ showLoadingEl: false });
    });
  }

  /**
   * hides submit button so the user can't click it multiple times during stripe api communication
   *
   * @param {object} state
   * @param {boolean} state.showLoadingEl - indicates if loading animation should be visible or not
   * @private
   */
  _togglesSubmitButton({ showLoadingEl }) {
    if (this.loadingElement && this.submitButton) {
      this.submitButton.classList.toggle(this.hiddenClass, showLoadingEl);
      this.loadingElement.classList.toggle(this.hiddenClass, !showLoadingEl);
    }
  }
}

export default FormSubmission;
